// Public FEEL API — the surface meant for external consumers and for the
// rest of @epx/dmn (simulator, decision-table evaluation, literal
// expressions, properties panel helpers, etc.).

export { tokenize, T, FeelLexError } from './Lexer';
export { parse, FeelParseError, Parser } from './Parser';
export { evaluate, evalAst, FeelEvalError } from './Evaluator';
export {
  compileUnaryTests,
  evaluateUnaryTests,
  FeelUnaryError,
} from './UnaryTest';
export {
  BUILTINS,
  BUILTIN_ALIASES,
  resolveBuiltin,
  truthy,
  deepEqual,
  stringify,
} from './builtins';
export { FUNCTION_CATALOG, FUNCTION_CATEGORIES } from './catalog';
